export default __webpack_public_path__ + "media/images/portfolio/gallery-01-370x220-9faf9f206f648434ee7e3e3b4a142ee7.jpg";